const digitsOnly = (value: string) => value.replace(/\D/g, '')

/**
 * Swedish personnummer / samordningsnummer gender:
 * The gender digit is the last digit of the 3-digit individual number,
 * i.e. the second-to-last digit of the whole number.
 *
 * odd = male, even = female
 */
export const getGenderFromSwedishSsn = (identificationNumber?: string | null): string => {
  if (!identificationNumber) return '-'

  const digits = digitsOnly(identificationNumber)

  // Supported common formats:
  // - YYMMDDNNNC  (10 digits)
  // - YYYYMMDDNNNC (12 digits)
  if (digits.length !== 10 && digits.length !== 12) return '-'

  const genderDigitIndex = digits.length === 12 ? 10 : 8 // second-to-last digit
  const genderDigitChar = digits[genderDigitIndex]
  const genderDigit = Number(genderDigitChar)

  if (!Number.isInteger(genderDigit)) return '-'

  return genderDigit % 2 === 0 ? 'Female' : 'Male'
}
